import {
    faStepBackward,
    faStepForward,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useRegistrarAcordoContext } from "..";
import { IDescontos } from "../../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { valueAsNumberOr0 } from "../../../../../Tools/FormatTools";
import IndicadoresDeValor from "../IndicadoresDeValor";
import ParcelasEscolhidas from "../ParcelasEscolhidas";

export default function EscolhaDescontos() {
    const {
        goToStep,
        calcularDescontos,
        descontosRef,
        lstParcelasSelecionadasComDescontos,
    } = useRegistrarAcordoContext();

    const { register, handleSubmit } = useForm<IDescontos>();

    const [loading, setLoading] = useState(false);

    const handleNextEtapaClick = () => {
        goToStep("selecModelo");
    };

    const handleCalcularDescontosFormSubmit = async (formData: IDescontos) => {
        setLoading(true);
        calcularDescontos(formData).finally(() => setLoading(false));
    };

    return (
        <div className="mt-5">
            <IndicadoresDeValor />
            <h3 className="mt-5">Selecione os descontos</h3>
            <form
                className="row mb-5"
                onSubmit={handleSubmit(handleCalcularDescontosFormSubmit)}
            >
                <div className="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
                    <label>Honorário (%)</label>
                    <input
                        type="number"
                        name="honorarioPercentual"
                        ref={register({
                            setValueAs: valueAsNumberOr0,
                        })}
                        defaultValue={
                            descontosRef.current?.honorarioPercentual ?? 0
                        }
                        step={0.01}
                        className="form-control"
                    />
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
                    <label>Honorário (R$)</label>
                    <input
                        type="number"
                        name="honorarioFinanceiro"
                        ref={register({
                            setValueAs: valueAsNumberOr0,
                        })}
                        defaultValue={
                            descontosRef.current?.honorarioFinanceiro ?? 0
                        }
                        step={0.01}
                        className="form-control"
                    />
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
                    <label>Desconto Multa (%)</label>
                    <input
                        type="number"
                        name="descontoMultaPercentual"
                        ref={register({
                            setValueAs: valueAsNumberOr0,
                        })}
                        defaultValue={
                            descontosRef.current?.descontoMultaPercentual ?? 0
                        }
                        step={0.01}
                        className="form-control"
                    />
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
                    <label>Desconto Juros (%)</label>
                    <input
                        type="number"
                        name="descontoJurosPercentual"
                        ref={register({
                            setValueAs: valueAsNumberOr0,
                        })}
                        defaultValue={
                            descontosRef.current?.descontoJurosPercentual ?? 0
                        }
                        step={0.01}
                        className="form-control"
                    />
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
                    <label>Desconto (%)</label>
                    <input
                        type="number"
                        name="descontoPercentual"
                        ref={register({
                            setValueAs: valueAsNumberOr0,
                        })}
                        defaultValue={
                            descontosRef.current?.descontoPercentual ?? 0
                        }
                        step={0.01}
                        className="form-control"
                    />
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
                    <label>Desconto (R$)</label>
                    <input
                        type="number"
                        name="descontoFinanceiro"
                        ref={register({
                            setValueAs: valueAsNumberOr0,
                        })}
                        defaultValue={
                            descontosRef.current?.descontoFinanceiro ?? 0
                        }
                        step={0.01}
                        className="form-control"
                    />
                </div>
                <div className="col-12 mt-2 d-flex justify-content-end">
                    <button className="btn btn-primary">
                        {loading ? (
                            <div
                                className="spinner-border spinner-border-lg text-white"
                                role="status"
                            >
                                <span className="sr-only">Carregando...</span>
                            </div>
                        ) : (
                            "Calcular"
                        )}
                    </button>
                </div>
            </form>
            <ParcelasEscolhidas />
            <div className="d-flex justify-content-between mt-5">
                <button
                    className="btn btn-primary"
                    onClick={() => goToStep("selecParcelas")}
                >
                    <FontAwesomeIcon className="mr-2" icon={faStepBackward} />
                    Voltar
                </button>
                <button
                    disabled={!lstParcelasSelecionadasComDescontos || loading}
                    className="btn btn-primary"
                    onClick={handleNextEtapaClick}
                >
                    Próximo
                    <FontAwesomeIcon className="ml-2" icon={faStepForward} />
                </button>
            </div>
        </div>
    );
}
